'use strict';

window.$ = window.jQuery = require('jquery');
window.bootstrap = require('bootstrap');
window.select2 = require('select2');
window.ClipboardJS = require('clipboard');

require('../common/constants');
require('../common/pagination');
require('../common/utils');
require('../common/clipboard');
require('../common/select-custom');
require('../common/address');
require('../common/favorite');
require('../common/header');
require('../common/search-form');
require('./home');
require('./newsletter');
